module.exports = __webpack_public_path__ + "static/media/icon_userInfo_upload.ca5ce16b.png";